interface IconProps {
  className?: string;
}

/**
 * Lucide "message-circle" glyph, filled. Inlined because the shared sprite
 * (~/components/Icon) does not include a solid message-circle icon.
 */
const MessageCircleIcon = ({ className }: IconProps) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden className={className}>
    <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" fill="currentColor" />
  </svg>
);

export default MessageCircleIcon;
